module.exports = __webpack_public_path__ + "static/media/logo-white.7b6ba383.png";